import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { Ornament } from './Ornament';
export function Guarantee() {
  return <section className="bg-surface-subtle px-4 py-20 sm:py-28" data-id="element-157" data-mp="1o5zqy212ub4m">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative mx-auto max-w-4xl overflow-hidden rounded-2xl border border-accent/50 bg-surface p-8 text-center shadow-card sm:p-12" data-id="element-158" data-mp="222wh019dfokg">
        <span className="mx-auto inline-flex h-20 w-20 items-center justify-center rounded-full border border-accent/60 bg-background text-accent" data-id="element-159" data-mp="1j52e84yu69ai">
          <ShieldCheckIcon size={38} strokeWidth={1.25} aria-hidden="true" data-id="element-160" data-mp="1ecizh4oex844" />
        </span>
        <h2 className="mt-6 text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-161" data-mp="qmojwfcpl5g6">
          <span className="italic text-primary" data-id="element-162" data-mp="lodcscdst91n">7-Day</span> Product Guarantee
        </h2>
        <Ornament className="mt-5" data-id="element-163" data-mp="oygncjtz1mcx" />
        <p className="mx-auto mt-7 max-w-2xl text-base font-semibold leading-7 text-foreground" data-id="element-164" data-mp="oxfaqaxb4rt3">
          You have 7 days to review the material after purchase.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-muted-foreground" data-id="element-165" data-mp="yqmbtjl0llnd">
          If the material you receive is incorrect, defective, incomplete or
          materially different from what was advertised, contact our support
          team within the applicable period and your case will be reviewed
          according to the guarantee policy.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-6 text-muted-foreground" data-id="element-166" data-mp="f12hfe5ocfyv">
          The product is delivered digitally in PDF format.
        </p>
      </motion.div>
    </section>;
}